/**
 * Drawing helper functions for receipt rendering
 */

const drawLine = (ctx: CanvasRenderingContext2D, y: number): number => {
  ctx.beginPath();
  ctx.setLineDash([5, 3]);
  ctx.moveTo(0, y);
  ctx.lineTo(ctx.canvas.width, y);
  ctx.stroke();
  return 8;
};

const drawTextCenter = (
  ctx: CanvasRenderingContext2D,
  y: number,
  fontSize: number,
  content: string,
  underline: boolean = false,
  overline: boolean = false
): number => {
  if (!content) return 0;
  ctx.font = `${fontSize}px sans-serif`;
  ctx.textAlign = 'center';
  ctx.fillText(content, ctx.canvas.width / 2, y);
  if (underline) {
    drawLine(ctx, y + fontSize * 0.5);
  }
  if (overline) {
    drawLine(ctx, y - fontSize * 1.1);
  }
  return fontSize * 1.5;
};

function getLines(ctx: CanvasRenderingContext2D, text: string, maxWidth: number): string[] {
  const words = text.split(' ');
  const lines: string[] = [];
  let currentLine = words[0];

  for (let i = 1; i < words.length; i++) {
    const word = words[i];
    const width = ctx.measureText(currentLine + ' ' + word).width;
    if (width < maxWidth) {
      currentLine += ' ' + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  }
  lines.push(currentLine);
  return lines;
}

const drawTableRow = (
  ctx: CanvasRenderingContext2D,
  y: number,
  fontSize: number,
  content: string[]
): number => {
  ctx.font = `${fontSize}px sans-serif`;
  const [left, mid, right] = content;
  const mx = 32;
  ctx.textAlign = 'right';
  ctx.fillText(right, ctx.canvas.width - mx, y);
  ctx.textAlign = 'left';
  ctx.fillText(left, mx, y);
  const lines = getLines(ctx, mid, 400);
  lines.forEach((line, index) => {
    ctx.fillText(line, mx * 3, y + index * fontSize);
  });
  return lines.length * fontSize * 1.5;
};

export { drawLine, drawTextCenter, drawTableRow };

